import { H2, Main, Paragraph } from "App/global-style";
import { IllustrationName, MainPath } from "Constants/constants";
import React, { useEffect } from "react";

import Box from "@storeblocks/box";
import { Illustration as FailureIllustration } from "@storeblocks/icon";
import { Link } from "react-router-dom";
import { buttonNextTrackId } from "Utils/analytics";
import { getCartIdFromCookie } from "Utils/cookies/cookiesUtil";
import { isDefined } from "Utils/functions";
import { setDocumentTitle } from "Utils/navigation/navigationUtils";

export const RedirectErrorPage = (): React.ReactElement => {
  const cartIdFromCookie = getCartIdFromCookie();

  useEffect(() => {
    setDocumentTitle("Problem med navigering");
  });

  return (
    <Main>
      <Box flexDirection="column">
        <Box justifyContent="center">
          <FailureIllustration name={IllustrationName.CUSTOMER_SERVICE_WOMAN} />
        </Box>
        <Box p={24} flexDirection="column" alignContent="left">
          <H2 id="main">Vi pusser opp sidene våre</H2>
          <Paragraph>
            Du har visst blitt navigert feil. Hvis du ønsker å legge til flere
            forsikringer i handlekurven din, ring oss på 67 51 93 00 mellom
            08:00 og 16:00 på hverdager, så hjelper vi deg.
          </Paragraph>
          {isDefined(cartIdFromCookie) && (
            <Paragraph>
              Ønsker du å kjøpe forsikringene du allerede har lagt i
              handlekurven, kan du{" "}
              <Link
                to={`/${MainPath.OFFER}/${getCartIdFromCookie()}`}
                data-trackid={buttonNextTrackId("see-cart")}
              >
                gå tilbake til handlekurven her
              </Link>
              .
            </Paragraph>
          )}
        </Box>
      </Box>
    </Main>
  );
};
